import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "declaration pt-4 container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8 order-lg-first order-md-last" }
const _hoisted_4 = { class: "container-fluid mt-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", null, "Draft", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = { class: "col-lg-4 order-lg-last order-md-first" }
const _hoisted_8 = { class: "m-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("small", { class: "text-primary fw-light mb-2" }, "Order Related Innovation Proposals for Postpartum Hermorrhage", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeclarationForm = _resolveComponent("DeclarationForm")!
  const _component_List = _resolveComponent("List")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseSearch = _resolveComponent("BaseSearch")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DeclarationForm),
        _createElementVNode("section", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createVNode(_component_List, { data: _ctx.data }, null, 8, ["data"]),
          _createVNode(_component_router_link, {
            class: "text-decoration-underline",
            to: "#"
          }, {
            default: _withCtx(() => [
              _createTextVNode("View draft")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("section", _hoisted_8, [
          _createVNode(_component_BaseSearch),
          _hoisted_9
        ])
      ])
    ])
  ]))
}